import { Injectable, Inject, LOCALE_ID } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler } from '@angular/common/http';

@Injectable()
export class LanguageInterceptor implements HttpInterceptor {
  constructor(@Inject(LOCALE_ID) private lang: string) {
    if (this.lang === 'en') {
      this.lang = 'en-US';
    }
  }

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    // Get the auth token from the service.
    const headers = req.headers.set('Accept-Language', this.lang);
    // const headers = req.headers.set('Accept-Language', 'en-US');

    const langReq = req.clone({
      headers
    });

    // send cloned request with header to the next handler.
    return next.handle(langReq);
  }
}
